import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a9 9 0 0 1 5.162 16.372l-5.162 -7.372v-9","fill":"currentColor","stroke":"none","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

const IconPercentage40 = createReactComponent('outline', 'percentage-40', 'Percentage40', __iconNode);

export default IconPercentage40;